<template>
  <div class="filter-container">
    <q-select
      class="filter"
      v-for="(filter, key) in filters"
      :key="key"
      v-model="filter.value"
      :label="filter.label"
      :options="filter.options.filter((option) => option?.trim())"
      use-chips
      multiple
      outlined
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  computed: {
    // The filters are directly bound to modelValue
    filters() {
      return this.modelValue;
    }
  },
  watch: {
    filters: {
      handler(newFilters) {
        // Emit the updated value to the parent component when filters change
        this.$emit("update:modelValue", newFilters);
      },
      deep: true // Deep watch to track changes in the nested values
    }
  }
};
</script>

<style scoped>
  .filter-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }

  .filter {
    flex: 1 1 200px;
    min-width: 0;
    /* height: 4rem; */
    overflow-y: auto;
    background-color: white;
  }
</style>